/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link, Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../../_metronic/layout";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import Activationemail from "./activateEmail";
import ResetPassword from "./resetPassword";
import ForgotPassword from "./ForgotPassword";
import Login from "./Login";
import Registration from "./Registration";
import RegistrationTaap from "./RegistrationTaap";
import TermsConditionsPage from "./Terms/Terms-Conditions"
import FaqPage from "./Faq/faq"
import PrivacyPolicyPage from "./PrivacyPolicy/PrivacyPolicy"
import { useTranslation } from "react-i18next";
import { LiveTrackingPage } from "../../../pages/livetracking/live-tracking";
import withTracker from "../../../withTracker";
import Loginsso from "./Loginsso";

export function AuthPage() {
  const { t } = useTranslation()
  const today = new Date().getFullYear();
  return (
    <>
      <div className="d-flex flex-column flex-root" >
        {/*begin::Login*/}

        <Switch>
          <ContentRoute path="/auth/login" component={Login} />
          <ContentRoute path="/auth/LoginSSO" component={Loginsso} />

          <ContentRoute path="/livetracking/:id" component={withTracker(LiveTrackingPage)} />
          <ContentRoute
            path="/auth/registration"
            component={withTracker(Registration)}
          />
          {t('Reset_Password')}

          <ContentRoute
            path="/ResetPassword"
            component={withTracker(ResetPassword)}
          />
          <ContentRoute
            path="/terms"
            component={withTracker(TermsConditionsPage)}
          />
          <ContentRoute
            path="/faq"
            component={FaqPage}
          />
           <ContentRoute
            path="/privacy-policy"
            component={PrivacyPolicyPage}
          />
          <ContentRoute
            path="/useractivationemail"
            component={Activationemail}
          />

          <ContentRoute
            path="/auth/registrationtaap"
            component={withTracker(RegistrationTaap)}
          />
          <ContentRoute
            path="/auth/forgot-password"
            component={withTracker(ForgotPassword)}
          />
          <Redirect from="/auth" exact={true} to="/auth/login" />
          <Redirect to="/auth/login" />
        </Switch>

      </div>
      {/*end::Content body*/}

      {/* begin::Mobile footer */}
      {!String(window.location.href).includes("/auth/login") === true ?
        <>
          <div className="d-none d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
            <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
              {today} &copy; Shipper
            </div>
            <div className="d-flex order-1 order-sm-2 my-2">
              <Link to="/terms" className="text-dark-75 text-hover-primary">
                {t('Privacy')}
              </Link>
              <Link
                to="/terms"
                className="text-dark-75 text-hover-primary ml-4"
              >
                {t('Legal')}
              </Link>
              <Link
                to="/terms"
                className="text-dark-75 text-hover-primary ml-4"
              >
                {t('Contact')}
              </Link>
            </div>
          </div>
        </>
        : ""
      }

      {/* end::Mobile footer */}

    </>
  );
}
